<template>
  <vue-bottom-sheet ref="orderBillBottomSheet" :rounded="true" @closed="false">
    <div style="max-height: 90vh; max-width: 100vw">
    <div class="bill-close-button d-flex align-items-center" @click="close">
      <span class="material-icons pl-2">close</span>
    </div>
<!--      <template slot="header">-->
        <div class="order-type-header w-100 h-auto px-3" style="min-height: 70vh">
          <div class="d-flex pt-2">
            <div class="divider-dark w-50 mt-3"></div>
            <p class="text-center px-3 font-weight-bold">Table {{ table }}</p>
            <div class="divider-dark w-50 mt-3"></div>
          </div>
          <div v-if="orderData.length">

            <div class="w-100">

              <div class="d-flex flex-column">
                <div v-for="item in orderData" :key="item.UniqueCode" class="d-flex justify-content-between pt-4">
                  <div class="d-flex pr-2">
                      <span>{{ item.Quantity  }}</span>
                  </div>

                  <div class="d-flex" style="min-width: 50%">
                    <span>{{ item.Name || item.Product ? item.Product.ProductName : '' }}</span>
                  </div>

                  <div class="d-flex flex-column text-center pl-2">
                    <span>${{  item.UnitPrice || item.Product ? item.Product.Rate : item.RawDisplayingUnitPrice }}</span>
                    <span v-if="item.Status === 4"  class="badge badge-pill bg-success badge-secondary px-3 py-2">Fulfilled</span>
                    <span v-else  class="badge badge-pill bg-dark badge-secondary px-3 py-2">Sent</span>
                  </div>
                </div>

                <div class="d-flex flex-column justify-content-between mt-4">

                  <!--GST-->
                  <div class="d-flex justify-content-between pt-2">
                    <div class="d-flex pr-2">
                      <span>GST</span>
                    </div>
                    <div class="d-flex flex-column text-center pl-2">
                      <span>${{ gst }}</span>
                    </div>

                  </div>

                  <!--Surcharge-->
                  <div class="d-flex justify-content-between pt-3">
                    <div class="d-flex pr-2">
                      <span>Surcharge</span>
                    </div>
                    <div class="d-flex flex-column text-center pl-2">
                      <span>${{ surcharge.toFixed(2) }}</span>
                    </div>

                  </div>

                  <!-- Total-->
                  <div class="d-flex justify-content-between pt-3">
                    <div class="d-flex pr-2 pt-1">
                      <span>Total</span>
                    </div>
                    <div class="d-flex flex-column text-center pl-2">
                      <span  class="badge badge-pill bg-dark badge-secondary px-3 py-2 font-16">${{ total.toFixed(2) }}</span>
                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            style="margin-top: 50px;"
            class="text-center"
          >
            <h3>No order items</h3>
          </div>
        </div>
        </div>

  </vue-bottom-sheet>
  </template>

  <script>
  import { mapActions } from 'vuex';
  import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
  export default {
    name: 'OrderBill',
    components: {
      VueBottomSheet
    },
    props: {
      errorMessage: {
        type: String,
        default: "",
      },
      orderData: {
        type: Array,
        default: null,
      },
      total: {
        type: Number,
        default: 0,
      },
      gst: {
        type: Number,
        default: 0,
      },
      surcharge: {
        type: Number,
        default: 0,
      },
      table: {
        type: String,
        default: "",
      },
    },
    methods: {
      ...mapActions(['setDisplayBill']),
      closeModal() {
        this.setDisplayBill(false);
      },
      open() {
        this.$refs.orderBillBottomSheet.open();
      },
      close() {
        this.$refs.orderBillBottomSheet.close();
      }
    },

  }
  </script>

  <style>
  .order-bill {
    width: 200px;
    margin-top: 40px;
  }
</style>
